import React from 'react'

import { Page } from '../../../../components/layouts/page'
import { Column } from '../../../../components/layouts/columns'
import { Form } from '../../../../components/ui/form'
import { FormReports } from './form/formReports'
import useEditReports from './hooks/useAdminEditReports'

export const AdminEditReports = () => {
  const { loading, formContext, setFormContext, handleEditConsent } = useEditReports()

  return (
    <Page.Section className="is-fullheight-with-navbar">
      <Form.Root
        action={() => {
          handleEditConsent()
        }}
      >
        <Column.Root>
          <Column.Content>
            <p className="subtitle is-size-3">Relatório</p>
          </Column.Content>
        </Column.Root>
        <FormReports loading={loading} values={formContext} setValues={setFormContext} disabledList={{}} />
      </Form.Root>
    </Page.Section>
  )
}
